import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  ClaimRequest, ClaimResponse, InspectionsRequest, InspectionsResponse,
  ChannelsRequest, ChannelsResponse, CoveragesRequest, CoveragesResponse,
  PoliciesRequest, PoliciesResponse, VehiclesRequest, VehiclesResponse,
  FilesRequest,
  FilesResponse,
  ClaimFormRequest,
  ClaimFormResponse,
  UploadFileResponse
} from '../interfaces/accidents.interface';
import { map, Observable } from 'rxjs';

export type endpoints = {
  Claims: {
    path: '/Claims',
    request: ClaimRequest,
    response: ClaimResponse,
  },
  Policies: {
    path: '/Policies',
    request: PoliciesRequest,
    response: PoliciesResponse,
  },
  Inspections: {
    path: '/Inspections',
    request: InspectionsRequest,
    response: InspectionsResponse[],
  },
  Vehicles: {
    path: '/Vehicles',
    request: VehiclesRequest,
    response: VehiclesResponse,
  }
  Channels: {
    path: '/Channels',
    request: ChannelsRequest,
    response: ChannelsResponse,
  },
  Coverages: {
    path: '/Coverages',
    request: CoveragesRequest,
    response: CoveragesResponse,
  }
  files: {
    path: '/files',
    request: FilesRequest,
    response: FilesResponse,
  }
}


@Injectable({
  providedIn: 'root'
})
export class AccidentsService {
  private apiUrl = environment.int365_dom + '/api/v1'
  constructor(private http: HttpClient, private authService: AuthService) { }


  getData<T extends keyof endpoints>(
    endpoint: T, // Clave del endpoint
    request: endpoints[T]['request'] // Tipo de request asociado
  ): Observable<endpoints[T]['response']> {

    const apiUrl = `${this.apiUrl}/${endpoint}`;
    return this.http
      .get<endpoints[T]['response']>(apiUrl, this.getHttpOptions(request))
      .pipe(
        map((response) => {
          try { return response }
          catch (error: any) { return error }
        }),
      );
  }
  // Envío de formulario
  postData(request: ClaimFormRequest): Observable<ClaimFormResponse> {
    return this.http
      .post<ClaimFormResponse>(
        `${this.apiUrl}/Claims`,
        request,
        this.getHttpOptions()
      )
      .pipe(
        map((response) => {
          try { return response }
          catch (error: any) { return error }
        }),
      );
  }

  // Subida de archivos
  uploadFile(request: FormData): Observable<UploadFileResponse> {
    return this.http
      .post<UploadFileResponse>(
        `${this.apiUrl}/uploadfile`,
        request,
        this.getHttpOptionsFiles()
      )
      .pipe(
        map((response) => {
          try { return response }
          catch (error: any) { return error }
        }),
      );
  }

  // Autenticación
  private getHttpOptions(params?: any) {
    const token = this.authService.getToken();
    if (!token) throw new Error('No token found');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return {
      headers,
      params: params
        ? new HttpParams({ fromObject: this.formatParams(params) })
        : undefined,
    };
  }
  private getHttpOptionsFiles(params?: any) {
    const token = this.authService.getToken();
    if (!token) throw new Error('No token found');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return {
      headers,
      params: params
        ? new HttpParams({ fromObject: this.formatParams(params) })
        : undefined,
    };
  }

  // Formato de parámetros
  private formatParams(params: any): { [key: string]: string } {
    const formattedParams: { [key: string]: string } = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (value instanceof Date) {
        formattedParams[key] = value.toISOString().split('T')[0];
      } else {
        formattedParams[key] = String(value);
      }
    });

    return formattedParams;
  }
}
